import styled from "styled-components";
import { theme } from "../../styles/theme";

export const FileWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 5px;
  background-color: ${theme.colors.white};
  margin-bottom: 10px;
  width: 100%;
  min-height: 40px;
  height: auto;
  padding: 6px 0;
`;

export const FileNameWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const UploadWrapper = styled.div`
  width: 100%;
  .ant-upload {
    display: block;
    width: 100%;
  }
  .ant-upload > .ant-btn,
  .ant-upload .ant-btn {
    width: 100%;
  }
`;
